@if (show) {
  <ol class="breadcrumb">
    @for (breadcrumb of breadcrumbs; track breadcrumb.url ?? breadcrumb.label; let last = $last) {
      <li [class.active]="last || breadcrumb.passive">
        @if (!last && !breadcrumb.passive) {
          <a [routerLink]="[breadcrumb.url, breadcrumb.params]">
            <ng-container *ngTemplateOutlet="linkLabel"></ng-container>
          </a>
        } @else {
          {{breadcrumb.label | translate }}
        }
        <ng-template #linkLabel>{{breadcrumb.label | translate }}</ng-template>
      </li>
    }
  </ol>
}